import { Component, Optional, Inject, Input, ViewChild, OnInit, ElementRef, ViewEncapsulation, OnChanges, SimpleChanges } from '@angular/core';
import { NgModel, NG_VALUE_ACCESSOR, NG_VALIDATORS, NG_ASYNC_VALIDATORS, FormBuilder } from '@angular/forms';
import { ElementBase } from 'src/app/core/form/element-base';
import { debounceTime, distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { StringUtilityServ } from 'src/app/core/services/utilities/string.service';
import { MenuComponent } from '../../../inputs/menu/menu.component';
import { Observable } from 'rxjs';
import { WidgetService } from 'src/app/core/http/web/widget.service';

@Component({
  selector: 'app-exp-hotels',
  templateUrl: './exp-hotels.component.html',
  styleUrls: ['./exp-hotels.component.scss'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: ExpHotelsComponent, multi: true }
  ]
})
export class ExpHotelsComponent extends ElementBase<any>
  implements OnInit {
  @Input() public placeholder: string;
  @Input() public data: any;
  @Input() public default: any = '';
  @Input() public submit: boolean;
  @Input() mobileMode: any = false;
  @ViewChild(NgModel) model: NgModel;
  @ViewChild('tg') tg: ElementRef;
  @ViewChild('menuModal') menuModal: MenuComponent;
  public dataFiltred: any;
  public airportList: any;
  public valueInpt: string;
  public serching = false;
  // public form: FormGroup;

  constructor(
    @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
    @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
    private fb: FormBuilder,
    private strServ: StringUtilityServ,
    private wtServ: WidgetService
  ) {
    super(validators, asyncValidators);
  }

  ngOnInit() {
    this.airportList = this.data;
    this.airportList = [];
  }

  checkFocus() {
    this.tg.nativeElement.focus();
  }

  checkClick() {
    this.menuModal.openMenu();
  }

  clickInput() {
    const vl: any = this.value.name ? this.removeHTML(this.value.name) : '';
    this.valueInpt = vl;
    this.filterGroupAirport(vl, this.mobileMode);
  }
  changeInput(event) {
    this.filterGroupAirport(this.valueInpt, this.mobileMode);
  }
  setValueSelected(data) {
    this.value = data;
    this.closeModal();
  }

  formatter = (x: { caption: string }) => {
    return (x && typeof x !== 'string' ? this.removeHTML(x.caption) : x || '');
  }
  // search = (text$: Observable<string>) => text$.pipe(
  //   debounceTime(200),
  //   map(term => {
  //     if (term === '') {
  //       return [];
  //     }
  //     return this.filterGroupAirport(term);
  //   })
  // )

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      switchMap(term => {
        if (term === '') {
          this.serching = false;
          return new Observable<any>(observer => observer.next([]));
        } else {
          this.serching = true;
          return this.wtServ.getDestinations(term).map(value => {
            this.serching = false;
            this.airportList = value.suggestions;
            return this.filterGroupAirport(term);
            // return value;
          }).catch(err => {
            this.serching = false;
            return [];
          });
        }
      })
    )

  // Recorremos los grupos aeropuertos en busca de una coincidencia
  filterGroupAirport(term: any, movil = false) {
    let filter = [];
    this.airportList = movil ? [] : this.airportList;

    if (this.airportList.length > 0) {
      this.airportList.forEach(group => {
        // if (this.strServ.ecualsNoAcents(group.name, term)) {
        //   console.log("acento: ", group, term);

        //   this.airportList[group].forEach(subGroup => {
        //     console.log("Sub: ", subGroup);

        //     filter.push(subGroup);
        //   });
        // } else {
        filter = this.filterSubAirport(group, term, filter);
        // }
      });
      console.log("Filtros: ", filter);
      this.dataFiltred = this.resaltTerm(filter.slice(0, 8), term);
      return this.dataFiltred;
    } else {
      this.wtServ.getDestinations(term ? term : 'mexico').subscribe((res: any) => {
        console.log('Respuesta: ', res);
        this.airportList = res.suggestions;

        this.airportList.forEach(group => {
          // if (this.strServ.ecualsNoAcents(group.name, term)) {
          //   console.log("acento: ", group, term);

          //   this.airportList[group].forEach(subGroup => {
          //     console.log("Sub: ", subGroup);

          //     filter.push(subGroup);
          //   });
          // } else {
          filter = this.filterSubAirport(group, term, filter);
          // }
        });
        console.log("Filtros: ", filter);
        this.dataFiltred = this.resaltTerm(filter.slice(0, 8), term);
        return this.dataFiltred;
      }, error => {
        console.error('Error: ', error);
        return [];
      });
    }
  }

  resaltTerm(data, term) {
    if (!this.mobileMode) {
      return data;
    }
    data.forEach(e => {
      e.newTitle = this.strServ.strAutocompl(this.removeHTML(e.caption), term);
      e.newSubtitle = this.strServ.strAutocompl(this.removeHTML(e.caption), term);
    });
    return data;
  }

  // Filtramos buscamos dentro de un grupo especifico
  filterSubAirport(item: any, term: string, object: any) {
    item.entities.filter(row => (
      // this.strServ.ecualsNoAcents(row.iata, term) ||
      this.strServ.ecualsNoAcents(this.removeHTML(row.caption), term)
    )).forEach(element => {
      object.push(element);
    });
    return object;
  }

  // Ordenamos los grupos
  ordenarAeropuertos(data: any) {
    const res = [];
    data.sort((a, b) => {
      return a.priority - b.priority;
    }).forEach(subGroup => {
      res.push(subGroup);
      subGroup.relacionados.forEach(relacionado => {
        relacionado.relacionado = true;
        res.push(relacionado);
      });
    });
    return res;
  }
  closeModal() {
    this.menuModal.closeMenu();
    this.valueInpt = '';
  }

  removeHTML(html) {
    return html.replace(/<[^>]*>/g, '');
  }

}
